import { render, staticRenderFns } from "./CountryBox.vue?vue&type=template&id=02705256&scoped=true&"
import script from "./CountryBox.vue?vue&type=script&lang=js&"
export * from "./CountryBox.vue?vue&type=script&lang=js&"
import style0 from "./CountryBox.vue?vue&type=style&index=0&id=02705256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02705256",
  null
  
)

export default component.exports